import React from 'react';
import { SVGProps } from './type';

const Icon = ({ fill }: SVGProps) => (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M4 1.5A0.999 0.999 0 0 0 3 2.501v17.995a0.999 0.999 0 1 0 1.999 0V3.5h5.998v16.996a0.999 0.999 0 1 0 1.999 0V12.498h5.998v7.998a0.999 0.999 0 1 0 1.999 0V11.498a0.999 0.999 0 0 0 -0.999 -1.001H12.997V2.501A0.999 0.999 0 0 0 11.998 1.5zm3.498 3.999a0.999 0.999 0 0 0 -0.999 0.999V7.5c0 0.552 0.447 1.001 0.999 1.001h1.001a0.999 0.999 0 0 0 0.999 -1.001v-1.001a0.999 0.999 0 0 0 -0.999 -0.999zm-0.999 5.998c0 -0.552 0.447 -1.001 0.999 -1.001h1.001c0.552 0 0.999 0.449 0.999 1.001v1.001a0.999 0.999 0 0 1 -0.999 0.999h-1.001a0.999 0.999 0 0 1 -0.999 -0.999zm0.999 3.999a0.999 0.999 0 0 0 -0.999 1.001v0.999c0 0.552 0.447 1.001 0.999 1.001h1.001a0.999 0.999 0 0 0 0.999 -1.001v-0.999a0.999 0.999 0 0 0 -0.999 -1.001zm7.998 -0.999a0.999 0.999 0 0 0 -0.999 0.999v1.001c0 0.552 0.447 0.999 0.999 0.999h1.001a0.999 0.999 0 0 0 0.999 -0.999v-1.001a0.999 0.999 0 0 0 -0.999 -0.999z"
    fill={fill}
  />
);

export default Icon;
